<!-- 报表执行页面 -->
<template>
    <div class="basis-page-cls">
        <section class="basis-cls_filter">
            <table-search :filterHeader="filterHeader" :defaultQuery="queryInfo" @filterSearch="getList" />
        </section>

        <section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> {{tableTitle}}</span>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-download" size="small" @click="getList({operFlag:'export'})">导出数据</el-button>
                </div>

            </div>
            <div class="table">
                <table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="queryInfo.pageNumber"
                    :limit.sync="queryInfo.pageSize"
                    @pagination="getList" />
            </div>
        </section>

    </div>
</template>

<script>

import { Message } from 'element-ui'
import { mapGetters } from 'vuex';
import { Encrypt } from '@/utils/crypto'
import { parseTime } from '@/utils';

    export default {
        components: {
        },
        data() {
            return {
                needRangeList: ["date","datetime","month"],
                // 列表数据
                column: [],
                // 表头数据
                filterHeader: [],
                reportId: "",
                queryInfo: {
                    pageNumber: 1,
                    pageSize: 10,
                },
                hiddenInfo: {

                },
                total: 0,

                // 表数据
                list: [],
                tableTitle: "",
                // 查找项的配置
                configData: [],
                /*时间控件的属性
                 *itemName => {
                 *  unit: _item.optionValidator.unit,
                 *  time: _item.optionValidator.time,
                 *  showType: _item.showType,
                 *  itemName: _item.itemName,
                }*/
                timeRange: new Map(),
                firstTime: true,
                canExport: true,
                exportReportHandler: null
            }
        },
        computed: {
            ...mapGetters([
                'userInfo',
                'subBrandList',
                'channelList'
            ]),
        },
        watch: {
        },
        creat(){
        },
        mounted() {
            this.tableTitle = this.$route.params.reportName || "报表数据";
            this.getReportData();
            // this.searchReport();
        },
        beforeDestroy() {
          this.clearExportTimeout();
        },
        methods: {
            // 生成表格
            genTable(tableData){
              if(this.firstTime){
                let column = [];
                for(let col of tableData.columns){
                  column.push({
                    label: col.title,
                    prop: col.field,
                  })
                }
                this.column = column;
                this.firstTime = false;
              }
              this.list = tableData.rows;
            },
            // 初始化搜索框
            initFilterHeader(reportConfigData){
              let { itemList } = reportConfigData;
              if(!itemList)return;
              let filterHeader = [];
              let _queryInfo = {};
              for(let _item of itemList){
                const { item } = _item;
                console.log(item);
                let filterItem = this.genFilterItem(_item);
                filterHeader.push(filterItem);

                // 初始化表单数据
                if(item.accessType == "hidden") {
                  this.hiddenInfo[item.itemCode] = item.defaultValue;
                }else{
                  if(item.showType == "date" || item.showType == "datetime"){
                    if(item.defaultValue){
                      try{
                        let timeArr = item.defaultValue.map(val=>{
                          return new Date(val).getTime();
                        })
                        if(item.isRequired) _queryInfo[item.itemCode] = timeArr;
                      }catch(err){
                        console.log(err);
                      }
                    }else{
                      let startTime = new Date();
                      startTime.setHours(0,0,0);
                      let endTime = new Date();
                      endTime.setHours(23,59,59);
                      if(item.isRequired) _queryInfo[item.itemCode] = [startTime.getTime(),endTime.getTime()];
                    }
                  }else{
                    _queryInfo[item.itemCode] = item.defaultValue;
                  }
                }

                if(item.optionInterface){
                  this.getSelectItem(item.optionInterface)
                    .then(rs => {
                      filterItem.list = rs.data;
                    })
                }
              }
              // console.log(filterHeader);
              this.filterHeader =filterHeader;
              this.queryInfo = Object.assign(_queryInfo,this.queryInfo);
              // console.log(this.queryInfo);
            },
            // 初始化timeRangeMap
            inittimeRangeData(reportConfigData){
              let { itemList } = reportConfigData;
              if(!itemList)return;
              for(let item of itemList){
                let _item = item.item;
                if(this.needRangeList.includes(_item.showType)){
                  this.timeRange.set(_item.itemCode,{
                    unit: _item.optionValidator.unit,
                    time: _item.optionValidator.time,
                    showType: _item.showType,
                    itemName: _item.itemName,
                    isRequired: _item.isRequired
                  })
                }
              }
            },

            // 生成搜索选项
            genFilterItem(itemData){
              const { item, optionList } = itemData;
              if(item.accessType == "hidden") return {}
              switch(item.showType){
                case "month":
                  return {
                    label: item.itemName,
                    model: item.itemCode,
                    type: 'monthrange',
                    default: [Date.now(),Date.now()],
                    disabled: item.accessType == "read"
                  }
                case "date":
                  return {
                    label: item.itemName,
                    model: item.itemCode,
                    type: 'daterange',
                    default: [Date.now(),Date.now()],
                    disabled: item.accessType == "read"
                  }
                case "datetime":
                  return {
                    label: item.itemName,
                    model: item.itemCode,
                    type: 'datetimerange',
                    default: [Date.now(),Date.now()],
                    disabled: item.accessType == "read"
                  }
                case "select":
                  return {
                    label: item.itemName,
                    model: item.itemCode,
                    type: 'select',
                    default: item.defaultValue,
                    labelName: "optionName",
                    valueName: "optionCode",
                    list: optionList,
                    placeholder: `请选择${item.itemName}`,
                    disabled: item.accessType == "read"
                  }
                case "multipleSelect":
                  return {
                    label: item.itemName,
                    model: item.itemCode,
                    type: 'select',
                    multiple: true,
                    default: item.defaultValue,
                    labelName: "optionName",
                    valueName: "optionCode",
                    list: optionList,
                    placeholder: `请选择${item.itemName}`,
                    disabled: item.accessType == "read"
                  }
                case "text":
                  return {
                      label: item.itemName,
                      model: item.itemCode,
                      type: 'input',
                      default: item.defaultValue,
                      placeholder: `请输入${item.itemName}`,
                      disabled: item.accessType == "read"
                  }
                default:
                  return {};
              }
            },

            // 通过url请求下拉项
            async getSelectItem(url){
              var myHeaders = new Headers();
              myHeaders.append("Authorization", localStorage.getItem("access_token"));
              myHeaders.append("User-Agent", "apifox/1.0.0 (https://www.apifox.cn)");
              myHeaders.append("Content-Type", "application/json");

              var requestOptions = {
                 method: 'GET',
                 headers: myHeaders,
                 redirect: 'follow'
              };
              let response = await fetch(url, requestOptions)
              let result  = await response.text();
              let json = JSON.parse(result);
              return json;
            },

            setExportReportTimeout(){
              this.canExport = false;
              this.clearExportTimeout();
              this.exportReportHandler = setTimeout(()=>{
                this.canExport = true;
              },5000);
            },
            clearExportTimeout(){
              if(this.exportReportHandler){
                clearTimeout(this.exportReportHandler);
                this.exportReportHandler = null;
              }
            },
            // 查表
            getList(option){
              // console.log("请求数据", this.queryInfo);

              let itemList = this.configData.itemList;
              let _queryInfo = Object.assign({},this.queryInfo);

              // 校验日期框
              for(let item in _queryInfo){
                if(this.timeRange.has(item)){
                  let range = 1000 *60 *60 *24;
                  let timeData = this.timeRange.get(item);
                  // console.log(timeData)
                  if(timeData.unit == "年") range *= (30*12);
                  if(timeData.unit == "月") range *= 30;
                  range *= parseInt(timeData.time);
                  if(timeData.isRequired == "1" && (!_queryInfo[item] || _queryInfo[item].length < 2)){
                    Message.error({message: `请选选择${timeData.itemName}`})
                    return;
                  }
                  if(_queryInfo[item][1]-_queryInfo[item][0]>range){
                    Message.error({message: `${timeData.itemName}范围不能大于${timeData.time}${timeData.unit}`})
                    return;
                  }
                }
              }


              // 时间戳转yyyy-MM-dd HH:mm:ss
              for(let item in _queryInfo){
                if(this.timeRange.has(item)){
                  _queryInfo[item] = [parseTime(_queryInfo[item][0]),parseTime(_queryInfo[item][1])]

                  let { showType } = this.timeRange.get(item);
                  // 选项为日期时，截去时间
                  if(showType == "date"){
                    _queryInfo[item] = _queryInfo[item].map(timeStr=>timeStr.split(" ")[0])
                  }
                  // 选项为月份时，截去时间和日期
                  if(showType == "month"){
                    _queryInfo[item] = _queryInfo[item].map(timeStr=>timeStr.substring(0,7))
                  }
                }
              }

              if(option.operFlag){
                if(!this.canExport){
                  Message.error({message: `请勿频繁调用，五秒后再试`});
                  return;
                }else{
                  this.setExportReportTimeout();
                }
              }
              this.$api.reportViewExecutejson({
                reportId: this.$route.params.reportId,
                operFlag: option.operFlag||"", //"export"加上为下载方法
                ..._queryInfo,
                ...this.hiddenInfo
              })
              .then(rs=>{
                if(!rs) return false;
                if(option.operFlag){
                  this.$message({
                    type: 'success',
                    message: '已创建导出任务，请稍等。'
                  })
                  return;
                }
                this.total = rs.data.total;
                this.genTable(rs.data);
              })
/*              var myHeaders = new Headers();
              myHeaders.append("Authorization", localStorage.getItem("access_token"));
              myHeaders.append("User-Agent", "apifox/1.0.0 (https://www.apifox.cn)");
              myHeaders.append("Content-Type", "application/json");
              var raw = JSON.stringify({
                reportId: this.$route.params.reportId,
                operFlag: option.operFlag||"", //"export"加上为下载方法
                ..._queryInfo,
                ...this.hiddenInfo
              });

              var requestOptions = {
                 method: 'POST',
                 headers: myHeaders,
                 body: raw,
                 redirect: 'follow'
              };



              fetch("https://ccaas-stg.ocssaas.com/ocs-report/report/view/executejson", requestOptions)
                 .then(response => response.text())
                 .then(result => JSON.parse(result))
                 .then(json => {
                  console.log(json)
                  if(json.errcode == 50000){
                    Message.error({message: json.errmsg})
                  }
                  this.genTable(json.data);
                 })
                 .catch(error => {
                  console.log(error);
                 });*/
            },

            // 获取报表查询条件数据
            getReportData(){
              this.$api.reportExtractParamsAction({
                 reportId: this.$route.params.reportId,
              }).then(rs=>{
                if(!rs) return false;
                console.log(rs);
                let { data } = rs;
                  this.configData = data;
                  this.inittimeRangeData(data);
                  this.initFilterHeader(data);
             })
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>
